module.exports = __webpack_public_path__ + "static/media/pricing.043877c1.jpg";